module.exports = __webpack_public_path__ + "img/yakyai_logo.945432cf.png";